module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Snoozed-mail-5fed3ae2c4c946d5503b8ac4b6f15ce3.svg";